import React, { FunctionComponent } from 'react';

import { EditoLinkList as EditoLinkListType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';

import Link from './Link';

export type LinksProps = {
  links?: EditoLinkListType['links'];
};

const useStyles = () => {
  const { breakpoint } = useTheme();
  return {
    linksContainer: {
      flexGrow: 1,
      justifyContent: 'center',
    },
    links: {
      width: '100%',
      [breakpoint.up('xl')]: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
      },
    },
    link: {
      [breakpoint.up('md')]: {
        justifyContent: 'left',
      },
      [breakpoint.up('xl')]: {
        flex: '1 0 50%',
      },
    },
  } as const;
};

const Links: FunctionComponent<LinksProps> = (props) => {
  const { links } = props;
  const classes = useStyles();

  return (
    <Flex css={classes.linksContainer} margin={{ xs: 0, lg: [0, 0, 0, 4] }}>
      <Flex flexDirection="column" margin={[-1, 0]} css={classes.links}>
        {links?.map((link, i) => {
          return <Link key={i} margin={[1, 0]} css={classes.link} {...link} />;
        })}
      </Flex>
    </Flex>
  );
};

export default Links;
